import script from "./data-performance-registration-item.vue?vue&type=script&setup=true&lang=js"
export * from "./data-performance-registration-item.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__